export const RECORDING_MAX_TIME = 30;
export const RECORDING_WARNING_TIME = 10;
